var _this = this,
  _jsxFileName = "/builds/EgNbCExi/0/ramsey-solutions/ramsey-plus/survey-ui/src/components/InputCheckboxGroup/InputCheckboxGroup.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import React from "react";
import { useFormikContext } from "formik";
var InputCheckboxGroup = function InputCheckboxGroup(props) {
  var question = props.question,
    InputByQuestionType = props.InputByQuestionType;
  var formikProps = useFormikContext();
  var initCheckboxStateFromFormik = function initCheckboxStateFromFormik() {
    if (!formikProps.values) {
      return [];
    }
    var initiallyCheckedValues = _toConsumableArray(formikProps.values[question.alias]);
    var _question$options$fil = question.options.filter(function (option) {
        return option.none_of_the_above;
      }),
      _question$options$fil2 = _slicedToArray(_question$options$fil, 1),
      exclusiveCheckbox = _question$options$fil2[0];
    var isExclusiveCheckboxChecked = initiallyCheckedValues.includes(exclusiveCheckbox === null || exclusiveCheckbox === void 0 ? void 0 : exclusiveCheckbox.id);
    return question.options.map(function (option) {
      return {
        checked: initiallyCheckedValues.includes(option.id),
        disabled: isExclusiveCheckboxChecked && option.id !== exclusiveCheckbox.id,
        optionId: option.id
      };
    });
  };

  // Initialize (on each render) the checkbox states from formik, but include whether they should be disabled
  var checkedStates = initCheckboxStateFromFormik();
  var setAllOthersDisabled = function setAllOthersDisabled(option, noneCheckedState) {
    if (noneCheckedState) {
      formikProps.setFieldValue(question.alias, [option.id]);
    } else {
      formikProps.setFieldValue(question.alias, []);
    }
  };
  var getAllCheckedBoxes = function getAllCheckedBoxes(index) {
    var copyOfStates = _toConsumableArray(checkedStates);
    var currentCheckbox = copyOfStates[index];
    currentCheckbox.checked = !currentCheckbox.checked;
    var allChecked = copyOfStates.filter(function (box) {
      return box.checked;
    }).map(function (box) {
      return box.optionId;
    });
    return allChecked;
  };
  var handleCheckboxChange = function handleCheckboxChange(option, index) {
    return function (event) {
      if (!option.none_of_the_above) {
        // Update formik with an array of the checked values
        var allChecked = getAllCheckedBoxes(index);
        formikProps.setFieldValue(question.alias, allChecked);
        return;
      }

      // Deselect and disable everything else
      setAllOthersDisabled(option, event.target.checked);
      return;
    };
  };
  return /*#__PURE__*/React.createElement(React.Fragment, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 65,
      columnNumber: 5
    }
  }, question.options.map(function (option, index) {
    var _checkedStates$index = _objectSpread({}, checkedStates[index]),
      checked = _checkedStates$index.checked,
      disabled = _checkedStates$index.disabled;
    var inputQuestionTypeProps = {
      question: question,
      option: option,
      checked: checked,
      disabled: disabled
    };
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: index,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 70,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(InputByQuestionType, Object.assign({}, inputQuestionTypeProps, {
      onChange: handleCheckboxChange(option, index),
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 71,
        columnNumber: 13
      }
    })));
  }));
};
export default InputCheckboxGroup;